module.exports = __webpack_public_path__ + "img/diap-9-1.16694f5e.png";